<script>
    import {onMount} from 'svelte';
    import {fade} from 'svelte/transition';
    import isLoading from '../stores/loading-store';
    import {reservation, steps} from '../stores/reservation-store';
    import FormNavigation from './event-form-navigation.svelte';
    import {
        i18n,
        i18nStore,
    } from "svelte-translate";

    let duplicateBooking = false;

    const urlParams = new URLSearchParams(window.location.search);
    const conditionsUrl = window.conditionsUrl

    const dupeCheckUrl = `/${$i18nStore.language}/api/dupecheck/`;

    onMount(async () => {
        isLoading.set(true);
        let action = `${dupeCheckUrl}?park=${encodeURI($reservation.parkId)}&date=${encodeURI($reservation.jumpDate)}&email=${encodeURI($reservation.email)}&start=${encodeURI($reservation.timeSlot)}`;
        const settings = {
            method: 'GET',
        };
        const response = await fetch(action, settings);
        if (!response.ok) throw Error(response.message);
        try {
            let bookingStatus = await response.json();
            duplicateBooking = bookingStatus.duplicate;
        } catch (err) {
            throw err;
        }

        $steps.previousStep = 2;
        $steps.nextStep = 4;
        $steps.nextStepAllowed = false; //temp
        isLoading.set(false);
    });

</script>

<div out:fade="{{delay: 0, duration: 150 }}" in:fade="{{delay: 500, duration: 200 }}" class="pb-4">
    <form id="reservation-form" action="./" method="post" class="form-container">
        {#if duplicateBooking}<p use:i18n={"duplicateBookingMessage"}>This booking already exists. If you confirm, a
            second, identical, booking will be made.</p>
        {:else}
            <p class="Form-review-note" use:i18n={"reviewBookingMessage"}>Review your booking</p>
        {/if}

        <div class="Form-container">
            <div class="Form-split">
                <table class="Form-table md:w-1/2">
                    <tr class="Form-table-row">
                        <th scope="row" class="Form-table-label" use:i18n={"parkLabel"}>Park:</th>
                        <td class="Form-table-data">{$reservation.readableParkName}</td>
                    </tr>
                    <tr class="Form-table-row">
                        <th scope="row" class="Form-table-label" use:i18n={"dateLabel"}>Date:</th>
                        <td class="Form-table-data">{$reservation.readableJumpDate}</td>
                    </tr>
                    <tr class="Form-table-row">
                        <th scope="row" class="Form-table-label" use:i18n={"timeLabel"}>Time:</th>
                        <td class="Form-table-data">{$reservation.timeSlot}:00
                            - {$reservation.timeSlot + parseInt($reservation.duration, 10)}:00
                        </td>
                    </tr>
                    <tr class="Form-table-row">
                        <th scope="row" class="Form-table-label" use:i18n={"jumperCountLabel"}>Jumpers:</th>
                        <td class="Form-table-data">{$reservation.numJumpers}</td>
                    </tr>
                        <tr class="Form-table-row">
                            <th scope="row" class="Form-table-label" use:i18n={"socksCountLabel"}>Socks:</th>
                            <td class="Form-table-data">{$reservation.socks}</td>
                        </tr>
                </table>


            </div>
            <div class="Form-split">

                <table class="Form-table md:w-1/2">
                    <tr class="Form-table-row">
                        <th scope="row" class="Form-table-label" use:i18n={"firstNameLabel"}>First name:</th>
                        <td class="Form-table-data">{$reservation.firstName}</td>
                    </tr>
                    <tr class="Form-table-row">
                        <th scope="row" class="Form-table-label" use:i18n={"firstNameLabel"}>Last name:</th>
                        <td class="Form-table-data">{$reservation.lastName}</td>
                    </tr>
                    <tr class="Form-table-row">
                        <th scope="row" class="Form-table-label" use:i18n={"lastNameLabel"}>Email:</th>
                        <td class="Form-table-data">{$reservation.email}</td>
                    </tr>
                    <tr class="Form-table-row">
                        <th scope="row" class="Form-table-label" use:i18n={"phoneLabel"}>Mobile phone:</th>
                        <td class="Form-table-data">{$reservation.phone}</td>
                    </tr>
                    <tr class="Form-table-row">
                        <th scope="row" class="Form-table-label" use:i18n={"marketingRecapLabel"}>Marketing emails:</th>
                        <td class="Form-table-data">
                            {#if $reservation.marketingEmails}<span use:i18n={"yes"}>Yes</span>{:else}<span use:i18n={"no"}>No</span>{/if}
                        </td>
                    </tr>
                    <tr class="Form-table-row">
                        <th scope="row" class="Form-table-label"><span use:i18n={"conditionsRecapLabel1"}>I have accepted the </span><a href="{conditionsUrl}" class="link-standard" target="_blank" use:i18n={"conditionsRecapLabel2"}>general conditions and privacy policy of Kojump</a>:</th>
                        <td class="Form-table-data">
                            {#if $reservation.conditions}<span use:i18n={"yes"}>Yes</span>{:else}<span use:i18n={"no"}>No</span>{/if}
                        </td>
                    </tr>

                </table>
            </div>
        </div>
        <input type="hidden" name="venue" required="" id="id_venue" bind:value="{$reservation.parkId}"/>
        <input type="hidden" name="first_name" maxlength="100" required="" id="id_first_name"
               bind:value="{$reservation.firstName}"/>
        <input type="hidden" name="last_name" maxlength="100" required="" id="id_last_name"
               bind:value="{$reservation.lastName}"/>
        <input type="hidden" name="email" required="" id="id_email" bind:value="{$reservation.email}"/>
        <input type="hidden" name="phone" maxlength="100" required="" id="id_phone" bind:value="{$reservation.phone}"/>
        <input type="hidden" name="event_type" required="" id="id_event_type" bind:value="{$reservation.eventType}"/>
        <input type="hidden" name="time" min="10" max="23" required id="id_time" bind:value="{$reservation.timeSlot}"/>
        <input type="hidden" name="date" required id="id_date" bind:value="{$reservation.jumpDate}"/>
        <input type="hidden" name="participants" id="id_participants" bind:value="{$reservation.numJumpers}"/>
        <input type="hidden" name="socks" id="id_socks" bind:value="{$reservation.socks}"/>
        <input type="hidden" id="id_duration" name="duration" bind:value="{$reservation.duration}"/>
        <input type="hidden" name="csrfmiddlewaretoken" value="{window.csrfToken}"/>
        <input type="checkbox" name="force_duplicate" id="id_force_duplicate" bind:checked="{duplicateBooking}"
               style="display: none" aria-hidden="true">
        <input type="checkbox" name="marketing_emails" id="id_marketing_emails"
               bind:checked="{$reservation.marketingEmails}" style="display: none" aria-hidden="true">
                <input type="checkbox" name="conditions" id="id_conditions"
               bind:checked="{$reservation.conditions}" style="display: none" aria-hidden="true">

    </form>
    <FormNavigation/>
</div>

